export default __webpack_public_path__ + "static/img-wahoo-500x325-3b708e85fdccb9b29c766eae2b1b62f8.png";